@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader-bar-fade {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.15;
  }
}

.loader {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.bar {
  position: absolute;
  top: 0;
  left: 50%;
  width: 7px;
  height: 7px;
  margin-left: -2.5px;
  border-radius: 50%;
  background-color: v.$palette-orange-2;
  transform-origin: 50% 16px;
  animation: loader-bar-fade 0.8s linear infinite;

  &:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -0.7s;
  }
  &:nth-child(2) {
    transform: rotate(45deg);
    animation-delay: -0.6s;
  }
  &:nth-child(3) {
    transform: rotate(90deg);
    animation-delay: -0.5s;
  }
  &:nth-child(4) {
    transform: rotate(135deg);
    animation-delay: -0.4s;
  }
  &:nth-child(5) {
    transform: rotate(180deg);
    animation-delay: -0.3s;
  }
  &:nth-child(6) {
    transform: rotate(225deg);
    animation-delay: -0.2s;
  }
  &:nth-child(7) {
    transform: rotate(270deg);
    animation-delay: -0.1s;
  }
  &:nth-child(8) {
    transform: rotate(315deg);
    animation-delay: 0s;
  }
}

.text {
  font-family: v.$primary-font;
  @include t.text(14px, 22px, semi-bold);
  color: v.$palette-orange-2;
  white-space: nowrap;
}
